import { defineMessage, defineMessages, IntlShape } from "react-intl";

import { PinnedFieldsVisibility } from "@mapmycustomers/shared";
import RoleEnum from "@mapmycustomers/shared/enum/Role";
import Visibility from "@mapmycustomers/shared/enum/Visibility";

export const messages = defineMessages<PinnedFieldsVisibility>({
  [Visibility.PRIVATE]: {
    id: "pinnedFields.field.visibility.onlyMe",
    defaultMessage: "Only me",
    description: "Private option for the pinned fields visibility",
  },
  [Visibility.SHARED_WITH_ORGANIZATION]: {
    id: "pinnedFields.field.visibility.entireOrg",
    defaultMessage: "Entire Org",
    description: "Entire Org option for the pinned fields visibility",
  },
  [Visibility.SHARED_WITH_TEAM]: {
    id: "pinnedFields.field.visibility.teams",
    defaultMessage: `{teamCount, plural, one {# team} other {# teams}}`,
    description: "Shared With Team option for the pinned fields visibility",
  },
});

const myTeamMessage = defineMessage({
  id: "pinnedFields.field.visibility.myTeam",
  defaultMessage: "My Team",
  description: "Shared With My Team display text for the pinned fields visibility",
});

const getVisibilityDisplayName = (
  intl: IntlShape,
  visibility: PinnedFieldsVisibility,
  role: RoleEnum,
  teamCount?: number
) =>
  intl.formatMessage(
    role !== RoleEnum.OWNER && visibility === Visibility.SHARED_WITH_TEAM
      ? myTeamMessage
      : messages[visibility],
    { teamCount }
  );

export default getVisibilityDisplayName;
